import { jsx as _jsx } from "react/jsx-runtime";
import { employeeTids } from '../../constants/tids';
import { DatePickerISO } from '../DatePickerISO';
import { FieldWrapper } from '../FieldWrapper';
export const BirthdayField = ({ value, required, onValueChange, validationInfo, labelClassName, width, disabled, }) => {
    return (_jsx(FieldWrapper, { label: "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F", labelClassName: labelClassName, children: _jsx(DatePickerISO, { value: value, onValueChange: onValueChange, validationInfo: validationInfo, "data-tid": employeeTids.birthdayInput, width: width, disabled: disabled }) }));
};
